module.exports = __webpack_public_path__ + "static/iphone@2x-51c754d306194ffef92dc1660a1a8d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/devices/iphone@2x.png
// module id = 921
// module chunks = 115276404313086 271422636699454